import  { useEffect, useState } from 'react';
import SignInCarosel from '../employer/signInCarousel'
import { ReactComponent as LoginBg } from '../../assets/images/sign-in-bg.svg';
import { Button } from '@mui/material';
import { ReactComponent as LoginBack } from '../../assets/images/left-nav.svg';
import { useNavigate } from 'react-router-dom';
import './style.scss'
// EMPLOYER BANNER FUNCTION 
const EmployerBanner = () => {
  const navigate = useNavigate();
  const [locationValue, setLocationValue] = useState('');

  // GOBACK FUNCTION 
  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const locationIp = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setLocationValue(data?.city);
      } catch (error) {
        console.log('location_error', error);
      }
    };

    locationIp();
  }, []);

  return (
    <div className="SinginFormLeft" style={{ backgroundColor: '#F5FAFF' }}>
      <Button className='loginBackBtn' onClick={handleGoBack} style={{ backgroundColor: 'rgb(245, 250, 255)' }}>
        <LoginBack />
        <span>Back</span>
      </Button>
      <LoginBg className="SinginFormBgImg BannerSVG" />
      <div className="SinginFormCarouselContainer">
        <div className="SinginFormCarouselTitle">
          Join over 15,000+ <br />
          Part Timers around {locationValue}
        </div>
        <SignInCarosel />
      </div>

    </div>
  );
}

export default EmployerBanner;